var map = {
	"./aretes-aro-grande.png": 1395,
	"./aretes-aro-pequeno.png": 1396,
	"./casco-bombero.png": 1397,
	"./casco-obrero.png": 1398,
	"./cascos-microfono.png": 1399,
	"./gorra-lana.png": 1400,
	"./gorra.png": 1401,
	"./gorro-cocinero.png": 1402,
	"./gorro-policia.png": 1403,
	"./hombre/colgante-cruz.png": 831,
	"./hombre/colgante-estrella-de-david.png": 832,
	"./hombre/colgante-medialuna.png": 833,
	"./lentes-pasta.png": 1404,
	"./lentes-policia.png": 1405,
	"./lentes-rocker.png": 1406,
	"./mujer/colgante-cruz.png": 834,
	"./mujer/colgante-estrella-de-david.png": 835,
	"./mujer/colgante-medialuna.png": 836,
	"./sombrero-de-paja.png": 1407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1394;